$font_family: Galano Grotesque, Segoe UI, sans-serif;

.tooltip {
  position: absolute;
  z-index: 30200;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 12px;
  background-color: #142f43;
  border-radius: 12px;
  color: #ffffff;
  font-family: $font_family;
  font-size: 14px;
  font-style: normal;
  font-weight: 400;
  letter-spacing: normal;
  line-break: auto;
  line-height: normal;
  transition: opacity ease 0.4s;
  white-space: nowrap;
  word-break: normal;
  word-spacing: normal;
  word-wrap: normal;
  animation: fadein 0.15s ease-in;
  animation-fill-mode: forwards;
  &.top,
  &.top-left,
  &.top-right {
    margin-top: -10px;
    transform: translate(-50%, -100%);
  }

  &.top-right {
    transform: translate(-100%, -100%);
  }

  &.top-left {
    transform: translate(0%, -100%);
  }

  &.bottom,
  &.bottom-left,
  &.bottom-right {
    margin-top: 10px;
    transform: translate(-50%, 0%);
  }

  &.bottom-right {
    transform: translate(-100%, 0%);
  }

  &.bottom-left {
    transform: translate(0%, 0%);
  }

  &.left,
  &.left-top,
  &.left-bottom {
    margin-left: -10px;
    transform: translate(-100%, -50%);
  }

  &.left-top {
    transform: translate(-100%, 0%);
  }

  &.left-bottom {
    transform: translate(-100%, -100%);
  }

  &.right,
  &.right-top,
  &.right-bottom {
    margin-left: 10px;
    transform: translate(0%, -50%);
  }

  &.right-bottom {
    transform: translate(0%, -100%);
  }

  &.right-top {
    transform: translate(0%, 0%);
  }

  &.white {
    border: 1px solid #d8dae5;
    background-color: #ffffff;
    border-radius: 0;
    box-shadow: 4px 4px 12px 0 rgba(0, 0, 0, 15%);
    color: #313131;
    font-size: 12px;
  }

  &.lineWrap {
    white-space: pre-wrap;
    word-break: break-word;
  }

  &.analytics {
    font-weight: 500;
    box-shadow: 0px 4.57207px 7.31532px rgba(0, 0, 0, 0.25);
    backdrop-filter: blur(2px);
    max-width: 200px;
    white-space: break-spaces;
  }
}

@keyframes fadein {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}
